/**
 * NCB API Public Client
 * Strictly handles non-authenticated public data fetching for public visitors.
 * Zero bcryptjs, auth, or admin dependencies here to keep bundle light and fast.
 */

const getEnv = (key) => {
  const val = import.meta.env[key];
  return val || '';
};

const INSTANCE = getEnv('VITE_NCB_INSTANCE') || '56134_pubhost';
const SECRET_KEY = getEnv('VITE_NCB_SECRET_KEY');
const DATA_URL = 'https://app.nocodebackend.com/api/data';

const publicDataFetch = async (path, options = {}) => {
  const sep = path.includes('?') ? '&' : '?';
  const url = `${DATA_URL}/${path}${sep}Instance=${INSTANCE}`;

  const headers = {
    'Content-Type': 'application/json',
    'X-Database-Instance': INSTANCE,
    ...options.headers,
  };

  if (SECRET_KEY) {
    headers['Authorization'] = `Bearer ${SECRET_KEY}`;
  }

  const res = await fetch(url, {
    ...options,
    headers,
  });

  let data;
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    data = await res.json();
  } else {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }

  if (!res.ok) {
    throw new Error(data?.message || data?.error || `API Error ${res.status}`);
  }

  return data;
};

const unwrap = (res) => {
  if (res && res.data !== undefined) return res.data;
  return res;
};

// ─── PUBLIC API ─────────────────────────────────────────
export const publicApi = {
  getPageBySlug: async (slug) => {
    if (!slug) return null;
    const cleanSlug = String(slug).trim();
    
    // First try published page query
    const res = await publicDataFetch(
      `read/pages?slug=${encodeURIComponent(cleanSlug)}&status=published&limit=1`
    );
    const data = unwrap(res);
    
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    }
    
    if (data && typeof data === 'object' && !Array.isArray(data) && data.slug) {
      return data;
    }

    // Fallback: search query if exact match query returns empty array
    try {
      const searchRes = await publicDataFetch('search/pages', {
        method: 'POST',
        body: JSON.stringify({ slug: cleanSlug, status: 'published' }),
      });
      const searchData = unwrap(searchRes);
      if (Array.isArray(searchData) && searchData.length > 0) {
        return searchData[0];
      }
    } catch {
      // Ignore search error and return null
    }

    return null;
  },

  getSiteById: async (id) => {
    if (!id) return null;
    try {
      const res = await publicDataFetch(`read/sites/${id}`);
      const data = unwrap(res);
      return Array.isArray(data) ? data[0] : data;
    } catch (err) {
      console.warn('[publicApi] getSiteById error:', err);
      return null;
    }
  },
};